import React, { Component } from "react";
import PropTypes from "prop-types";
import { cpfMask, cnpjMask, patternOnlyNumbers } from "../utils/masks";
import { getUserToken } from "../../../js/shared/utils";
import jwt_decode from "jwt-decode";
import InputForm from "../../atoms/InputForm";
import SelectForm from "../../atoms/SelectForm";
import AutoSuggestForm from "../../atoms/AutoSuggestForm";
import Select from "../../Select/Select";
import { isMobile } from "../../../../js/components/searchform/utils/common";

class BoxBankDetails extends Component {
	constructor() {
		super();
		this.state = {
			cpfcnpj: "",
			bankId: "",
			agency: "",
			account: "",
			errors: {
				cpfcnpj: false,
				bankId: false,
				agency: false,
				account: false
			}
		};

		this.onChange = this.onChange.bind(this);
		this.checkAllFilled = this.checkAllFilled.bind(this);
	}

	checkAllFilled() {
		const { checkData } = this.props;
		const { cpfcnpj, bankId, agency, account, errors } = this.state;

		let fieldsIsCompleted =
			!!cpfcnpj &&
			!!bankId &&
			!!agency &&
			!!account &&
			!errors.cpfcnpj &&
			!errors.bankId &&
			!errors.agency &&
			!errors.account;

		checkData("completedBoxDataBankDetails", fieldsIsCompleted);
	}

	onChange(event) {
		const { name, value } = event.target;
		const { setData } = this.props;
		const { errors, bankId } = this.state;

		switch (name) {
			case "cpfcnpj":
				this.setState({ errors: { ...errors, cpfcnpj: !value.length } });
				break;
			case "bankId":
				this.setState({
					[name]: value,
					errors: {
						...errors,
						bankId: !value,
						agency: value != 45 && this.state.agency.length > 4
					},
					agency: "",
					account: ""
				});
				setData({ [name]: value });
				break;
			case "agency":
				let agency = value.match(patternOnlyNumbers)
					? value
							.match(patternOnlyNumbers)
							.join("")
							.toString()
					: "";
				this.setState({
					[name]: bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency,
					errors: {
						...errors,
						agency: !agency.length || agency.length < 3 || (bankId != 45 && agency.length > 4)
					}
				});
				setData({ [name]: bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency });
				break;
			case "account":
				let account = value.match(patternOnlyNumbers)
					? value
							.match(patternOnlyNumbers)
							.join("")
							.toString()
					: "";
				this.setState({
					[name]: account.replace(/(\d)(\d{1}$)/g, "$1-$2"),
					errors: { ...errors, account: !account.length }
				});
				setData({ [name]: account.replace(/(\d)(\d{1}$)/g, "$1-$2") });
				break;
		}

		setTimeout(() => this.checkAllFilled(), 200);
	}

	componentWillMount() {
		const { bankData } = this.props;
		const { setData } = this.props;

		let token = getUserToken();
		let payload = jwt_decode(token);

		let cpfcnpj = bankData.cpfcnpj
			? bankData.cpfcnpj
			: payload.ssn
					.match(patternOnlyNumbers)
					.join("")
					.toString();
		let bankId = bankData.bankId ? bankData.bankId : "";
		let agency = bankData.agency ? bankData.agency : "";
		let account = bankData.account ? bankData.account : "";

		this.setState({
			cpfcnpj: cpfcnpj,
			bankId: bankId,
			agency: agency,
			account: account
		});
		setData({ cpfcnpj: cpfcnpj });

		setTimeout(() => this.checkAllFilled(), 200);
	}

	render() {
		const { className, options, setInputInFocus } = this.props;
		const { cpfcnpj, bankId, agency, account, errors } = this.state;

		const ruleMaskInputUser = cpfcnpj.length <= 14 ? cpfMask : cnpjMask;

		// let optionsBank = [{ label: "Selecione", value: "" }];
		let optionsBank = [];

		options.map(item => {
			optionsBank.push({
				label: item.name,
				value: item.idBank
			});
		});

		return (
			<div className={`box-bank-details ${className}`}>
				<p className="box-bank-details--title box-title">Dados bancários</p>
				<div className="row">
					<div className="col-xs-8">
						<InputForm
							ref={el => (this.inputUser = el)}
							name="cpfcnpj"
							id="cpfcnpj"
							value={cpfcnpj}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("cpfcnpj")}
							disabled={cpfcnpj}
							placeholder=""
							label="CPF do titular"
							mask={ruleMaskInputUser}
							hasError={errors.cpfcnpj}
							data-action="register-credit-card-cpfcnpj"
						/>
					</div>
					<div className="col-xs-8">
						<AutoSuggestForm
							name="bankId"
							options={optionsBank}
							defaultValue={bankId}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("bankId")}
							label="Banco"
							suggestionKeyToRender="label"
							suggestionKeyValueToUse="label"
							hasError={errors.bankId}
							data-action="register-bank-details-bank-select"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-4">
						<InputForm
							ref={el => (this.inputAgency = el)}
							name="agency"
							id="agency"
							type="tel"
							value={bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("agency")}
							placeholder=""
							label="Agência"
							maxLength={bankId == 45 ? 6 : 4}
							hasError={errors.agency}
							data-action="register-bank-details-agency"
						/>
					</div>
					<div className="col-xs-6">
						<InputForm
							ref={el => (this.inputAccount = el)}
							name="account"
							id="account"
							type="tel"
							value={account.replace(/(\d)(\d{1}$)/g, "$1-$2")}
							onChange={this.onChange}
							onFocus={() => setInputInFocus("account")}
							placeholder=""
							label="Conta corrente"
							maxLength="20"
							hasError={errors.account}
							data-action="register-bank-details-account"
						/>
					</div>
				</div>
			</div>
		);
	}
}

BoxBankDetails.propTypes = {
	bankData: PropTypes.object.isRequired,
	checkData: PropTypes.func,
	className: PropTypes.string,
	options: PropTypes.array.isRequired,
	setData: PropTypes.func,
	setInputInFocus: PropTypes.func
};

export default BoxBankDetails;
